// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("/Users/bberman/Documents/GlobalMeltdown/node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-js": () => import("/Users/bberman/Documents/GlobalMeltdown/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/Users/bberman/Documents/GlobalMeltdown/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-watch-js": () => import("/Users/bberman/Documents/GlobalMeltdown/src/pages/watch.js" /* webpackChunkName: "component---src-pages-watch-js" */)
}

